import { render } from "./ArticleInformationContainer.vue?vue&type=template&id=77d1572e&scoped=true"
import script from "./ArticleInformationContainer.vue?vue&type=script&lang=js"
export * from "./ArticleInformationContainer.vue?vue&type=script&lang=js"

import "./ArticleInformationContainer.vue?vue&type=style&index=0&id=77d1572e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d1572e"]])

export default __exports__